// authenticate.ts

import { createAccountListeners } from './authenticate/createAccountListeners';
import { loginOrRegisterListeners } from './authenticate/loginOrRegisterListeners';

document.addEventListener('DOMContentLoaded', function () {
	createAccountListeners();
	loginOrRegisterListeners();
});
